<!-- =========================================================================================
  File Name: InviteCamUserSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isCamUserSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4 style="word-break: normal;">ADD {{ $t('user.title') }} FOR:</h4>
        <vs-chip v-if="viewImg" color="primary" class="mr-10">
        <vs-avatar :src="img_cdn+viewImg"/>
        <p v-if="lng=='dogs'"> {{ dataFirstName}}</p>
        <p v-else> {{ dataFirstName+' '+dataLastName }}</p>
        </vs-chip>
        <vs-chip v-else color="primary" class="mr-10">
        <vs-avatar/>
        <p v-if="lng=='dogs'"> {{ dataFirstName}}</p>
        <p v-else> {{ dataFirstName+' '+dataLastName }}</p>
        </vs-chip>
        <feather-icon icon="XIcon" @click.stop="isCamUserSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <!-- <div v-if="dataCamUser.length>0" class="ml-3 mt-1">
     <h5>Existing User</h5>
    <ul  v-for="(CamUser, index) in dataCamUser" :key="index" >
      <li>
        <vs-chip color=primary> {{CamUser.fname}} {{CamUser.lname}}</vs-chip>
      </li>
      </ul>
    </div>
    <p v-else class="ml-3 mt-1">No Existing User</p> -->
    <vs-row>
    <vs-col vs-w="12">
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6" >
        <div class="flex">
          <!-- <vs-checkbox v-model="ExBox" @change="excheck(ExBox)">Choose existing Student</vs-checkbox> -->
          <vs-checkbox v-model="NewBox" @change="newcheck(NewBox)">Add New</vs-checkbox>
        </div>
        <br>
        <div v-if="ExBox">
        <label class="vs-select--label w-full">Select Existing {{ $t('user.titlesmall') }}</label>
        <v-select ref="selector" v-if="ExBox" label="name"  multiple :closeOnSelect="true" v-model="dataCamUser"  :options="camusers" :clearSearchOnSelect="true"/>
        </div>
        <!-- <vs-select  v-if="ExBox"  v-model="CamUser" label="Select User"  class="mt-5 w-full" autocomplete >
          <vs-select-item :key="item.id" :value="item" :text="item.fname+' '+item.lname+'  -  '+item.email" v-for="item in camusers" autocomplete />
        </vs-select> -->
        <!-- <vs-select v-if="ExBox" v-model="Sibling" label="Select Student"  class="mt-5 w-full">
          <vs-select-item :key="item.id" :value="item" :text="item.fname+' '+item.middle_name+' '+item.lname" v-for="item in siblings" />
        </vs-select> -->

      </div>
      <div class="pl-6 pr-6 " v-if="NewBox">

        <template >
          <!-- Image Container -->
          <div class="contained-example-container">
            <div id="div-with-loading" class="vs-con-loading__container">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center vs-con-loading__container" id="div-with-loading">

            <img loading="lazy" v-if="ImgName" :src="newUserImg" class="responsive">
          </div>
          </div>
            </div>
          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click.native="$refs.updateImgInput.click()">{{this.ImgName == null ? "Upload" : "Update" }} Image</vs-button>
            <vs-button v-if="ImgName!==null" type="flat" color="#999" @click.native="ImgName = null , newUserImg = null">Remove Image</vs-button>
          </div>
        </template>
        <!-- FIRST NAME -->
        <vs-input :label="$t('user.add.first_name')" v-model="dataCamFirstName" class="mt-5 w-full" :name="$t('user.add.first_name')" v-validate="'required'" maxLength="50"/>
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.first_name'))">{{ errors.first($t('user.add.first_name')) }}</span>
          <!-- Middle NAME -->
        <!-- <vs-input :label="$t('user.add.middle_name')" v-model="dataCamMiddleName" class="mt-5 w-full" :name="$t('user.add.middle_name')"  /> -->


        <!-- LAST NAME -->
        <vs-input :label="$t('user.add.last_name')" v-model="dataCamLastName" class="mt-5 w-full" :name="$t('user.add.last_name')" v-validate="'required'" maxLength="50"/>
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.last_name'))">{{ errors.first($t('user.add.last_name')) }}</span>

        <!-- EMAIL -->
        <vs-input :label="$t('user.add.email')" v-model="dataCamEmail" @input="acceptEmail" class="mt-5 w-full" :name="$t('user.add.email')"
          autocomplete="off"  maxlength="100" v-validate="'email|required'"/>
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.email'))">{{ errors.first($t('user.add.email')) }}</span>
        <span class="text-danger text-sm" v-if="Duplicate>0">{{$t('user.add.email')}} Already Exist!</span>

        <!-- PHONE -->
        <vs-input :label="$t('user.add.phone_no')" v-model="dataCamPhone" @input="acceptNumber" class="mt-5 w-full" :name="$t('user.add.phone_no')"  maxlength="50"/>
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.phone_no'))">{{ errors.first($t('user.add.phone_no')) }}</span>
        <span v-if="dataCamPhone.length > 0 &&  dataCamPhone.length < 14" class="text-danger text-sm">Invalid phone number format.</span>
            <!-- Send Invite Email -->
        <br>
        <vs-checkbox  @input="changeInviteEmailStatus(dataEmailInviteOption)" v-model="dataEmailInviteOption">{{ $t('user.add.invite_email') }}</vs-checkbox>
         <div v-if="!dataEmailInviteOption">
          <!-- Username -->
         <vs-input name="Username" :label="$t('user.add.user_name')" v-model="dataCamUserName" @input="checkUserName" class="mt-5 w-full" v-validate="'alpha_num|required'" maxlength="50"/>
        <span class="text-danger text-sm" v-show="errors.has('Username')">{{ errors.first('Username') }}</span>
        <span class="text-danger text-sm" v-if="UserDuplicate>0">UserName has  already been taken!</span>
        <br>
        <vx-input-group>
                  <template slot="append">
                    <div class="append-text cursor-pointer" style="color:#B0AFB7;background-color:white;border:1px solid rgba(0, 0, 0, 0.2); border-left:none">
                      <span @click="showPassword = !showPassword">
                              <feather-icon v-if="showPassword" icon="EyeOffIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                              <feather-icon v-else icon="EyeIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                        </span>
                    </div>
                  </template>

                  <vs-input 
                  ref="password"
                  v-model="dataPassword" 
                   data-vv-validate-on="blur"
                   v-validate="'required|min:6|max:20'"
                    v-bind:type="[showPassword ? 'text' : 'password']" 
                    name="password"
                    placeholder="Password"
                    class="w-full no-right-border"
                     maxlength="50"
                    
                  />
                </vx-input-group>
        <span class="text-danger text-sm">{{ errors.first('password') }}</span>

        <vs-input
          type="password"
          v-validate="'min:6|max:20|confirmed:password'"
          data-vv-validate-on="blur"
          data-vv-as="password"
          name="confirm_password"
          label-placeholder="Confirm Password *"
          placeholder="Confirm Password"
          v-model="dataConfPassword"
          class="w-full mt-6" 
           maxlength="50"/>
        <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

        </div>
        <br>
        <vs-row class="mb-5 ml-1">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
        <label>{{ $t('user.add.status') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
           <vs-switch v-model="pending" ></vs-switch>
        </vs-col>
        </vs-row>
         <!-- <vs-row class="mb-5 ml-1">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
        <label>{{ $t('user.add.status') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
           <vs-switch v-model="dataStatus"></vs-switch>
        </vs-col>
        </vs-row> -->
        <vs-row class="mb-5 ml-1">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
        <label>{{ $t('user.add.emergency_contact') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
          <vs-switch v-model="dataCamEcontact"></vs-switch>
        </vs-col>
        </vs-row>
      </div>
    </component>
     </vs-col>
    </vs-row>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">{{ $t('user.add.btn_submit') }}</vs-button>
      <vs-button type="border" color="danger" @click.native="isCamUserSidebarActiveLocal = false">{{ $t('user.add.btn_cancel') }}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment'
import vSelect from 'vue-select'

import {
  ALL_USERS,
  CREATE_STUDENT_USER,
  SINGLE_USER_BY_EMAIL,
  SINGLE_USER_BY_USERNAME,
  UPDATE_STUDENT,
  UPLOAD_IMAGE,
  ADD_USER_TO_SIBLING, CREATE_USER_ACTIVITY, UPDATE_USER_ACTIVITY,
  USER_BY_STUDENT_LOCATION,
  REMOVE_USER_FROM_STUDENT
} from '@/graphql'
import S3 from 'aws-s3'
const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url,
  dirName: process.env.VUE_APP_AWS_DIREC+'/UserImage',
}
const S3Client = new S3(config)
export default {
  props: {
    isCamUserSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      Duplicate:0,
      UserDuplicate:0,
      alphanumeric:0,
      CamUser:[],
      camusers:[],
      ExBox:true,
      NewBox:false,
      dataId: null,
      dataCamusers:[],
      dataCamImg: null,
      dataImg:null,
      newUserImg:'',
      ImgName:null,
      img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
      lng:'',
      oldimage:'',
      dataCamUserName: '',
      dataCamFirstName: '',
      dataCamMiddleName: '',
      dataCamLastName: '',
      dataCamName: '',
      dataCamEmail: '',
      dataCamPhone: '',
      enableInvitOption:true,
      dataCamEcontact: false,
      dataStatus: true,
      dataConf: false,
      pending:false,
      dataEmailInviteOption :true,
      dataFirstName:'',
      dataLastName:'',
      dataCamUser:[],
      viewImg:'',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      dataPassword:'',
      dataConfPassword:'',
      showPassword:false

    }
  },
  watch: {
    isCamUserSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
        this.enableInvitOption = true
      } else {
        const {id, fname, lname, middle_name, nick_name, image, dob, status, emergency_contact, location, program, cameras, users } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.viewImg = image
        this.dataImg = image
        this.dataProgram = program
        this.dataFirstName = fname
        this.dataMiddleName = middle_name
        this.dataLastName = lname
        this.dataNick = nick_name
        this.dataCamera = cameras
        // this.dataCamUser = users
        const getcamusers = []
        const getcamusersids = []
        // const getfullname=''
        for (let j = 0; j < users.length; j++) {
          getcamusersids.push(users[j].id)
          if (this.validEmail(users[j].email)) {
            users[j].name = `${users[j].fname} ${users[j].lname} - ${users[j].email}`
          } else {
            users[j].name = `${users[j].fname} ${users[j].lname}`
          }
          // users[j].name = getfullname
          getcamusers.push(users[j])
        }
        this.CamUser = getcamusersids
        this.dataCamUser = getcamusers
        this.dataLocation = location.id
        this.getStudentLocationUser(location.id)
        this.dataBirthday = dob
        this.dataStatus = status
        this.enableInvitOption = false
        this.initValues()
        // console.log(this.$refs.selector)
      }
    },
    NewBox(val){
     if(val){
       this.resetForm()
     }
    },
  },
  computed: {
    isCamUserSidebarActiveLocal: {
      get () {
        return this.isCamUserSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeCamUserSidebar')
          // this.$validator.reset()
          this.ExBox = true
          this.NewBox = false
          this.initValues()
        }
      }
    },
    isFormValid () {
      if (this.ExBox) {
        if(this.$refs.selector){
           return !this.errors.any() && this.CamUser && !this.$refs.selector.searching
        }
        else{
          return !this.errors.any() && this.CamUser
        }
        
      }
      if (this.NewBox) {
        if (this.dataEmailInviteOption) {
          return !this.errors.any() && this.dataCamFirstName && this.dataCamLastName && this.dataCamEmail && this.Duplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0 && (this.dataCamPhone == '' || this.dataCamPhone.length == 14)
        }
        if (!this.dataEmailInviteOption) {
          return !this.errors.any() && this.dataCamFirstName && this.dataCamLastName && this.dataCamUserName && this.dataPassword && this.dataConfPassword && this.dataCamEmail && this.Duplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0 && (this.dataCamPhone == '' || this.dataCamPhone.length == 14)
        }
      //  return !this.errors.any() && this.dataCamFirstName && this.dataCamLastName && this.dataCamEmail && this.Duplicate===0 && this.UserDuplicate===0 && this.alphanumeric===0 && (this.dataCamPhone =='' || this.dataCamPhone.length ==14)
      }

    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    openLoadingInDiv () {
      this.$vs.loading({
        type:'sound',
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    validEmail (value) {
      if (value.slice(0, 8) === 'temp-kv-'  &&  /^\d+$/.test(value.slice(9, 18))  &&  value.slice(value.length - 14) === 'kidsvision.com') {
        return false
      } else {
        return true
      }
    },
    StatusSuccess (action) {
      var text =''
      if(action==='added'){
          text = `${this.$t('user.alert_title')} ${action} successfully!`
      }
      else{
        text = `${this.$t('user.alert_title')}s ${action} successfully!`
      }
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: text,
        color: 'success',
        position: 'top-right'
      })
    },
    StatusFail () {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: 'Failed to add!',
        color: 'danger',
        position: 'top-right'
      })
    },
    resetForm(){
      this.dataCamImg = null
      this.dataCamFirstName = ''
      this.dataCamLastName = ''
      this.dataCamEmail = ''
      this.dataCamPhone = ''
      this.CamUser = []
      this.dataImg = null
      this.oldimage = ''
      this.dataCamUserName = ''
      this.dataCamMiddleName = ''
      this.dataCamEcontact = false
      this.dataEmailInviteOption = true
      this.dataCont = true
      this.dataStatus = true
      this.pending = false
      this.dataPassword = ''
      this.dataConfPassword = ''
    },
    initValues () {
      // if (this.data.id) return
      this.dataCamImg = null
      this.dataCamFirstName = ''
      this.dataCamLastName = ''
      this.dataCamEmail = ''
      this.dataCamPhone = ''
      this.CamUser = []
      this.dataImg = null
      this.oldimage = ''
      this.dataCamUserName = ''
      this.dataCamMiddleName = ''
      this.dataCamEcontact = false
      this.dataEmailInviteOption = true
      this.dataCont = true
      this.dataStatus = true
      this.pending = false
      this.dataPassword = ''
      this.dataConfPassword = ''
      this.ExBox = true
      this.NewBox = false,
      this.newUserImg=null

    },
    acceptEmail () {
      this.$apollo
        .mutate({
          mutation: SINGLE_USER_BY_EMAIL,
          variables: {
            email: this.dataCamEmail
          }
        })
        .then(response => {
          this.Duplicate = response.data.userByEmail.length
        })
    },
    // checkUserName () {
    //   const letterNumber = /[^a-zA-Z0-9]/g
    //   if (this.dataCamUserName.match(letterNumber)) {
    //     this.alphanumeric = 1
    //   } else if (this.dataCamUserName) {
    //     this.alphanumeric = 0
    //     this.$apollo
    //       .mutate({
    //         mutation: SINGLE_USER_BY_USERNAME,
    //         variables: {
    //           username: this.dataCamUserName
    //         }
    //       })
    //       .then(response => {
    //         this.UserDuplicate = response.data.userByUserName.length
    //       })
    //   }
    // },
   checkUserName () {
    if (this.dataCamUserName.length>0){
        this.$apollo
          .mutate({
            mutation: SINGLE_USER_BY_USERNAME,
            variables: {
              username: this.dataCamUserName
            }
          })
          .then(response => {
            this.UserDuplicate = response.data.userByUserName.length
          })
      }
      else{
        this.dataCamUserName=''
        this.UserDuplicate = 0
      }
    },
    submitData () {
      if (this.NewBox) {
        if (this.dataEmailInviteOption) {
          this.dataCamUserName = 'User'
        }
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$apollo
              .mutate({
                mutation: CREATE_STUDENT_USER,
                variables: {
                  fname: this.dataCamFirstName,
                  middle_name: this.dataCamMiddleName,
                  lname: this.dataCamLastName,
                  username: this.dataCamUserName,
                  phone: this.dataCamPhone,
                  email: this.dataCamEmail,
                  invite_email: this.dataEmailInviteOption,
                  email_confirmed: this.dataConf,
                  status: this.dataStatus,
                  pending:!this.pending,
                  avatar:this.ImgName,
                  emergency_contact:this.dataCamEcontact,
                  student_id: this.data.id,
                  location:this.dataLocation,
                  password: this.dataPassword
                }
              })
              .then(response => {
                if (response) {
                  // console.log(response)
                  this.StatusSuccess("added")
                  this.dataPassword = '',
                  this.dataConfPassword = '',
                  // console.log(this.data.id)
                  // console.log(response.data.createStudentUser.user.id)
                  this.$apollo
                    .mutate({
                      mutation: ADD_USER_TO_SIBLING,
                      variables: {
                        student_id: this.data.id,
                        // user_id: response.data.createStudentUser.user.id
                      }
                    }).then(response => {
                        this.$emit('getdata', true)
                    })
                  this.userActivity(response.data.createStudentUser.user.id)
                }
              }).catch(error => {
                console.log(error)
              })

            this.$emit('closeCamUserSidebar')
            this.initValues()
            this.$validator.reset()
            this.dataCamImg = null
            this.dataCamFirstName = ''
            this.dataCamLastName = ''
            this.dataCamEmail = ''
            this.dataCamPhone = ''
            this.ImgName = null
            this.dataImg = null
            this.oldimage = ''
            this.CamUser = '',
            this.dataCamUserName = ''
            this.dataCamMiddleName = ''
            this.dataCamEcontact = false
            this.dataEmailInviteOption = true
            this.dataCont = true
            this.dataStatus = true
            this.pending = false
            this.ExBox = true
            this.NewBox = false

          }
        })
      }
      if (this.ExBox) {
        this.$validator.validateAll().then(result => {
          const getcamuserids = []
          for (let j = 0; j < this.dataCamUser.length; j++) {
            const getid = this.dataCamUser[j].id
            getcamuserids.push(getid)
          }
          if (result) {
            if (this.dataBirthday) {
              this.dataBirthday = moment(this.dataBirthday).format('YYYY-MM-DD')
            }
        this.$apollo
        .mutate({
          mutation: REMOVE_USER_FROM_STUDENT,
          variables: {
            student:this.dataId,
            users:getcamuserids
          }
        }).then(response => {
          if (response) {
            this.$emit('getdata', true)
            this.StatusSuccess("updated")
            this.updateSibling(this.dataId)
            this.updateUserActivity(this.dataId)
          }
        }).catch(error => {
          console.log(error)
        })
            // this.$apollo
            //   .mutate({
            //     mutation: UPDATE_STUDENT,
            //     variables: {
            //       id:this.dataId,
            //       fname:this.dataFirstName,
            //       middle_name:this.dataMiddleName,
            //       lname: this.dataLastName,
            //       nick_name: this.dataNick,
            //       dob:this.dataBirthday,
            //       image:this.dataImg,
            //       status: this.dataStatus,
            //       location_id: this.dataLocation,
            //       program_id: this.dataProgram.id,
            //       users: this.dataCamUser
            //     }
            //   })
            //   .then(response => {
            //     if (response) {
            //       this.StatusSuccess()
            //       this.updateUserActivity()
            //     }
            //   }).catch(error => {
            //     console.log(error)
            //   })

            

            this.$emit('closeCamUserSidebar')
            this.$emit('getdata', true)
            this.CamUser = [],
            this.dataCamUser = [],
            this.dataCamImg = null
            this.dataCamFirstName = ''
            this.dataCamLastName = ''
            this.dataCamUserName = ''
            this.dataCamMiddleName = ''
            this.dataCamEmail = ''
            this.dataCamPhone = ''
            this.dataCamEcontact = false
            this.dataEmailInviteOption = true
            this.$validator.reset()
            this.initValues()
          }
        }
        )
      }
    },
    updateSibling(id){
    this.$apollo
              .mutate({
                mutation: ADD_USER_TO_SIBLING,
                variables: {
                  student_id:id,
                  // user_id: this.dataCamUser
                }
              }).then(response => {
          if (response) {
            this.$emit('getdata', true)
          }
        }).catch(error => {
          console.log(error)
        })
    },
    getStudentLocationUser (location_id) {
      this.cameras=[]
      this.$apollo
        .mutate({
          mutation: USER_BY_STUDENT_LOCATION,
          variables: {
            location_id
          }
        }).then(response => {
          if (response) {
            const camusers = []
            for (let i = 0; i < response.data.userByStudentLocation.user.length; i++) {
              const fullname = `${response.data.userByStudentLocation.user[i].fname} ${response.data.userByStudentLocation.user[i].lname} - ${response.data.userByStudentLocation.user[i].email}`
              response.data.userByStudentLocation.user[i].name = fullname
              camusers.push(response.data.userByStudentLocation.user[i])
            }
            this.camusers = camusers
          }
        })
    },
    userActivity (id) {
      this.$apollo
        .mutate({
          mutation: CREATE_USER_ACTIVITY,
          variables: {
            object_id: id,
            object_type:'App\\Models\\User',
            activity:'added'
          }
        }).then(response => {
          if (response) {
            this.updateUserActivity()
          }
        })
    },
    updateUserActivity () {

      this.$apollo
        .mutate({
          mutation: UPDATE_USER_ACTIVITY,
          variables: {
            object_id: this.dataId,
            object_type:'App\\Models\\Student',
            activity:'updated'
          }
        })
    },
    excheck (val) {
      this.NewBox = !val
    },
    // changeEmailConfirmationStatus(val){
    //   this.pending=!val
    // },
    changeInviteEmailStatus (val) {
      this.pending = !val
    },
    newcheck (val) {
      this.ExBox = !val
    },
    updateCurrImg (input) {
          const file = input.target.files[0]
          const name = Math.random().toString().slice(2)
          this.openLoadingInDiv()
          S3Client.uploadFile(file, name)
            .then(response => {
              this.ImgName = response.key
              this.newUserImg = this.img_cdn+response.key
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            })
            .catch(err => console.error(err))
      },
    // updateCurrImg (input) {
    //   if (input.target.files && input.target.files[0]) {
    //     const reader = new FileReader()
    //     reader.onload = e => {
    //       this.newUserImg = e.target.result
    //       this.openLoadingInDiv()
    //       this.$apollo
    //         .mutate({
    //           mutation: UPLOAD_IMAGE,
    //           variables: {
    //             image:this.newUserImg,
    //             oldimage:this.oldimage
    //           }
    //         })
    //         .then(response => {
    //           if (response) {
    //             this.oldimage = ''
    //             if (response.data.uploadImage.status == 'SUCCESS') {
    //               this.ImgName = response.data.uploadImage.image_name
    //               this.$vs.loading.close('#div-with-loading > .con-vs-loading')
    //             } else {
    //               this.ImgName = response.data.uploadImage.image_name
    //               this.UploadFail(response.data.uploadImage.error)
    //               this.$vs.loading.close('#div-with-loading > .con-vs-loading')
    //             }

    //           }
    //         }).catch(error => {
    //           console.log(error)
    //         })
    //     }
    //     reader.readAsDataURL(input.target.files[0])
    //   }
    // },
    acceptNumber () {
      const x = this.dataCamPhone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      this.dataCamPhone = !x[2]
        ? x[1]
        : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    }
  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
    
    // this.$apollo
    // .mutate({
    //   mutation: ALL_USERS,
    // })
    // .then(response => {
    //   response.data.role.users.length
    //    var camusers = [];
    //  for (let i = 0; i<response.data.role.users.length; i++) {
    //     var fullname = response.data.role.users[i].fname+' '+response.data.role.users[i].lname+' - '+response.data.role.users[i].email
    //     response.data.role.users[i].name = fullname;
    //     camusers.push(response.data.role.users[i])
    //   }
    //    this.camusers=camusers
    // })
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
